import { Injectable } from '@angular/core';
import { StatefulValue } from '@workflow/class/stateful-value.class';

@Injectable({
  providedIn: 'root'
})
export class StatefulService {
  public wrap(id: string, iterationId?: number, pageIterationId?: number): StatefulValue {
    // Using argument.length to determine the number of arguments passed to the function
    if (arguments.length === 3) {
      return new StatefulValue(id, iterationId, pageIterationId);
    } else if (arguments.length === 2) {
      return new StatefulValue(id, iterationId);
    } else {
      return new StatefulValue(id);
    }
  }
}
